import { Design, Intent } from 'enums';
import TextareaAutosize from 'react-textarea-autosize';
import styled, { css } from 'styled-components';

export interface InputBase {
  intent?: Intent | null;
  design?: Design | null;
}

export const base = css<InputBase>`
  display: block;
  width: 100%;
  height: 40px;
  padding: 1em;
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.lightPeriwinkle};
  border-radius: 3px;
  color: ${(props) => props.theme.colors.darkBlue};

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.blue};
  }

  &::placeholder {
    opacity: 1;
    color: ${(props) => props.theme.colors.steel};
  }

  // when error
  ${(props) =>
    props.intent === Intent.DANGER &&
    css`
      border-color: ${props.theme.colors.deepRose};
    `}

  :disabled {
    background-color: ${(props) => props.theme.colors.grey};
  }

  ${(props) =>
    props.design === Design.LARGE &&
    css`
      height: 50px;
      font-size: 16px;
      border-width: 2px;
    `}
`;

export const Input = styled.input<InputBase>`
  ${base};
`;

export const TextArea = styled(TextareaAutosize)<InputBase>`
  ${base};
  line-height: 1.4;
`;

interface IHelperText {
  level?: string;
  mt?: string;
}

export const HelperText = styled.p.attrs<IHelperText>((props) => ({
  color: props.level ? props.level : 'unknown',
}))<IHelperText>`
  margin-top: ${({ mt }) => mt || '8px'};
  ${(props) => props.theme.text.BodySmall};

  color: ${(props) => props.theme.colors.deepRose};
`;
